import React, { useContext } from 'react';
import { string } from 'prop-types';
import { PLCCPod } from '@thd-olt-component-react/consumer-card-messaging';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context';

export function PrivateLabelCreditCard({ id }) {
  const { isB2C } = useContext(HomepageContext);
  return (
    <ErrorBoundary name="consumer-card-messaging">
      <div
        id={`plcc-php-${id}`}
        className="sui-h-full"
      >
        <PLCCPod id={id} radiusUpdate={isB2C} />
      </div>
    </ErrorBoundary>
  );
}

PrivateLabelCreditCard.propTypes = {
  id: string,
};

PrivateLabelCreditCard.defaultProps = {
  id: undefined,
};
